/**
 * @generated SignedSource<<2a01f38e68928bd4fbd384a7e4c8feaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgreementBlock = "BAGGAGE" | "TRANSFER";
export type UpdateTermInput = {
  agreementBlock?: AgreementBlock | null;
  icon?: string | null;
  name?: string | null;
};
export type TermEditFormMutation$variables = {
  id: string;
  input: UpdateTermInput;
};
export type TermEditFormMutation$data = {
  readonly updateTerm: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "TermEditForm_term">;
  };
};
export type TermEditFormMutation = {
  response: TermEditFormMutation$data;
  variables: TermEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TermEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Term",
        "kind": "LinkedField",
        "name": "updateTerm",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TermEditForm_term"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TermEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Term",
        "kind": "LinkedField",
        "name": "updateTerm",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agreementBlock",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c70f21027d595ef679852d088eff38df",
    "id": null,
    "metadata": {},
    "name": "TermEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation TermEditFormMutation(\n  $id: ID!\n  $input: UpdateTermInput!\n) {\n  updateTerm(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...TermEditForm_term\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment TermEditForm_term on Term {\n  id\n  name\n  icon\n  agreementBlock\n}\n"
  }
};
})();

(node as any).hash = "ebd10780e89837bb55a24c861aebed94";

export default node;
